module.exports = __webpack_public_path__ + "static/media/sarcoma.9c3a5d5e.svg";